import styled from "styled-components";

const ReportMapWrap = styled.section`
  height: 100%;
  width: 100%;
  padding: 0px 4px;
  /* margin: 10px auto; */

  .map-toggles {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    h3 {
      margin: 0px;
    }

    .map-toggle-buttons {
      display: flex;
      align-items: center;

      .toggle {
        display: flex;
        align-items: center;
        margin-right: 5px;
        p {
          margin: 0px 3px;
        }
      }

      .switch {
        position: relative;
        display: inline-block;
        width: 38px;
        height: 22px;
      }

      /* Hide default HTML checkbox */
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      /* The slider */
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      input:checked + .slider {
        background-color: #60de4f;
      }

      input:focus + .slider {
        box-shadow: 0 0 1px #60de4f;
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(15px);
        -ms-transform: translateX(15px);
        transform: translateX(15px);
      }

      /* Rounded sliders */
      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }
`;

export { ReportMapWrap };
